import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, CheckCircle2, MailCheck, ShieldCheck } from 'lucide-react';
import Header from '../components/HomePage/header';

const Success = () => {
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    // Set a timer to redirect to the login page after 5 seconds
    const timer = setTimeout(() => {
      setRedirecting(true); // Set redirecting to true
      navigate('/dashboard');
    }, 5000); // Adjust the duration as needed

    // Cleanup timer on component unmount
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-5xl items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <section className="w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-200 bg-gray-50 px-6 py-5 sm:px-8">
            <div className="inline-flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-medium text-emerald-700">
              <ShieldCheck className="h-4 w-4" aria-hidden="true" />
              Secure payment confirmed
            </div>
          </div>

          <div className="grid gap-8 px-6 py-8 sm:px-8 lg:grid-cols-[1fr_280px] lg:items-center">
            <div>
              <div className="flex h-16 w-16 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600">
                <CheckCircle2 className="h-10 w-10" aria-hidden="true" />
              </div>
              <h1 className="mt-6 text-3xl font-bold text-gray-950 sm:text-4xl">
                Payment done
              </h1>
              <p className="mt-3 max-w-2xl text-base leading-7 text-gray-600">
                Thank you for completing your secure online payment. Your
                PrepNexis access is being prepared.
              </p>
              <div className="mt-6 rounded-lg border border-purple-100 bg-purple-50 px-4 py-4">
                <div className="flex gap-3">
                  <MailCheck
                    className="mt-0.5 h-5 w-5 flex-none text-purple-700"
                    aria-hidden="true"
                  />
                  <div>
                    <p className="font-semibold text-gray-950">
                      Verify your email before logging in.
                    </p>
                    <p className="mt-1 text-sm leading-6 text-gray-600">
                      Check your inbox for the verification email, then sign in
                      to continue to your dashboard.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                {/* Disable button if redirecting */}
                <a
                  href="/login"
                  className={`inline-flex items-center justify-center gap-2 rounded-lg bg-gray-900 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-gray-800 ${
                    redirecting ? 'cursor-not-allowed opacity-50' : ''
                  }`}
                  onClick={(e) => {
                    if (redirecting) e.preventDefault();
                  }}
                >
                  Login
                  <ArrowRight className="h-4 w-4" aria-hidden="true" />
                </a>
              </div>
            </div>

            <div className="rounded-lg border border-gray-200 bg-white p-5">
              <p className="text-sm font-semibold uppercase tracking-[0.14em] text-gray-500">
                Next step
              </p>
              <p className="mt-3 text-2xl font-bold text-gray-950">
                Go to dashboard
              </p>
              <p className="mt-2 text-sm leading-6 text-gray-600">
                You will be redirected automatically in a few seconds.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Success;
